<template>
  <div class="tabs">
    <div class="icon-container">
      <div class="tabs-icon" :class="'icon1' !== selectedIcon ? '' : 'isSelected'">
        <img
          id="icon1"
          @click="selectItem('icon1')"
          src="../../assets/icons/arrow.png" alt=""
        >
      </div>
      <div class="tabs-icon" :class="'icon2' !== selectedIcon ? '' : 'isSelected'">
        <img
          id="icon2"
          @click="selectItem('icon2')"
          src="../../assets/icons/clock.png"
          alt=""
        >
      </div>
      <div class="tabs-icon" :class="'icon3' !== selectedIcon ? '' : 'isSelected'">
        <img
          id="icon3"
          @click="selectItem('icon3')"
          src="../../assets/icons/globe.png"
          alt=""
        >
      </div>
      <div class="tabs-icon" :class="'icon4' !== selectedIcon ? '' : 'isSelected'">
        <img
          id="icon4"
          @click="selectItem('icon4')"
          src="../../assets/icons/globe.png"
          alt=""
        >
      </div>
    </div>

    <div class="info-boxes-container">
      <info-box
        :class="'icon1' !== selectedIcon ? '' : 'active'"
        box-title="FTO / PTO / CTO Programs"
      >
        <ul>
          <li>Fully customize your current program or create a new program.</li>
          <li>Track and record tasks and “other” training materials with a full sign flow hierarchy</li>
          <li>Review analytics reports that data mine results and compare performance of PO’s</li>
          <li>Move from paper/pencil forms and reports to automated reports</li>
          <li>Create tests, email notifications that include sign off waiting and late completion</li>
          <li>Optimized for Smartphones, Computers and Tablets</li>
        </ul>
      </info-box>
      <info-box
        :class="'icon2' !== selectedIcon ? '' : 'active'"
        box-title="EIS – Early Identification System"
      >
        <ul>
          <li>Track Use of Force, Vehicle Pursuits, and Review Body Cam on demand</li>
          <li>We use your forms to automate their completion and allow for reviews is required</li>
          <li>Hierarchy approval process allows problematic evals to push to supervisors/command staffs</li>
          <li>Use graphs and data collection to identify potential variances to department policy</li>
        </ul>
      </info-box>
      <info-box
        :class="'icon3' !== selectedIcon ? '' : 'active'"
        box-title="QM - Quartermaster"
      >
        <ul>
          <li>Add, Assign and Track Inventory by individual</li>
          <li>Notifications when nearing expiration such as Body Armor and OC Spray</li>
          <li>Track by SKU numbers, Camera scan, or QR Codes</li>
          <li>Collect data on “Grant” purchases</li>
          <li>Create your own approval hierarchy for requested items</li>
          <li>Manage your Motor Pool and associated inventory for every vehicle</li>
        </ul>
      </info-box>
      <info-box
        :class="'icon4' !== selectedIcon ? '' : 'active'"
        box-title="LMS - Learning Management System"
      >
        <ul>
          <li>Manage State mandated certifications as well as Career Paths</li>
          <li> Schedule In-House Courses and maintain waiting lists for future courses</li>
          <li> Maintain a departmental Fitness Program with percentile ratings based on age, weight, and gender</li>
          <li> Build your own On-Demand Computer Based Training Programs and much more</li>
        </ul>
      </info-box>
    </div>


  </div>
</template>

<script>
import InfoBox from "../productComponents/InfoBox";

export default {
  name: 'Tabs',
  components: {InfoBox},
  data: () => ({selectedIcon: 'icon1'}),
  methods: {
    selectItem(value) {
      this.selectedIcon = value
    }
  }
}
</script>

<style lang="scss">
@import "Tabs.scss";
</style>
